__turbopack_context__.v({
  "customer": "layout-module__IFsANq__customer",
  "customerName": "layout-module__IFsANq__customerName",
  "customerRole": "layout-module__IFsANq__customerRole",
  "formBody": "layout-module__IFsANq__formBody",
  "heading": "layout-module__IFsANq__heading",
  "is-collapsing": "layout-module__IFsANq__is-collapsing",
  "is-exiting": "layout-module__IFsANq__is-exiting",
  "is-logout-mounting": "layout-module__IFsANq__is-logout-mounting",
  "loginContainer": "layout-module__IFsANq__loginContainer",
  "loginFormSlot": "layout-module__IFsANq__loginFormSlot",
  "loginPage": "layout-module__IFsANq__loginPage",
  "loginVisual": "layout-module__IFsANq__loginVisual",
  "reviewFeedback": "layout-module__IFsANq__reviewFeedback",
  "starRating": "layout-module__IFsANq__starRating",
  "testimonial": "layout-module__IFsANq__testimonial",
  "vector": "layout-module__IFsANq__vector",
  "vector1": "layout-module__IFsANq__vector1",
  "vector2": "layout-module__IFsANq__vector2",
});
